import { render, staticRenderFns } from "./expand_bar.vue?vue&type=template&id=5b161cb2"
import script from "./expand_bar.vue?vue&type=script&lang=js"
export * from "./expand_bar.vue?vue&type=script&lang=js"
import style0 from "./expand_bar.vue?vue&type=style&index=0&id=5b161cb2&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports